import React from 'react';
import '../../App.css'


const QuantityControl = ({ value, increment, decrement, onChange }) => {
  return (
    <div className="flex items-center gap-2">
      <button onClick={decrement} className="px-2 py-1 bg-gray-300">-</button>
      <input
        type="number"
        value={value}
        onChange={onChange}
        className="w-12 text-center border rounded no-arrows"
        min="1"
      />
      <button onClick={increment} className="px-2 py-1 bg-gray-300">+</button>
    </div>
  );
};



export default QuantityControl